import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

const CONTENT_TYPES = [
  { value: 'post', label: 'Single Workpiece' },
  { value: 'projectGroup', label: 'Multi Workpiece' },
];

function ContentTypeFilter({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  return (
    <FilterMenu label="Content Type" submenu={submenu}>
      <DropdownMenuItem onClick={() => removeSearchParam('contentType')}>
        All Content
      </DropdownMenuItem>
      {CONTENT_TYPES.map((contentType) => (
        <DropdownMenuItem
          key={contentType.value}
          onClick={() => appendSearchParam('contentType', contentType.value)}
        >
          {contentType.label}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default ContentTypeFilter;
